import { Component, OnInit, OnDestroy } from '@angular/core';
import * as Stores from '@core/redux/stores';
import { isModifierGroupDefaultSelected } from '@core/redux/stores';
import { Observable ,  Subscription } from 'rxjs';

import { AlertService, ProxyService, MenuUtilityService, ModalService } from '@core/services';

import { ChildRecipeService } from '@features/ordering/services/child-recipe.service';

import { CustomizationService } from '@features/customization/services';
import * as Store from '@core/redux/stores';
import { select } from '@angular-redux/store';
import * as _ from 'lodash-es';
import { LoggingService } from '@core/services/logging.service';
@Component({
  selector: 'app-nutrition-allergens',
  templateUrl: './nutrition-allergens.component.html',
  styleUrls: ['./nutrition-allergens.component.less'],
  providers: [AlertService, CustomizationService]
})
export class NutritionAllergensComponent implements OnInit, OnDestroy {
  @select(appState => appState.childRecipe)
  childRecipeEntityAs: Observable<Stores.ChildRecipeEntity>;
  private subscriptions = new Subscription();
  public nutritionInfo = new Stores.NutritionInfo();
  private childRecipeEntity: Stores.ChildRecipeEntity;
  private selectedIngredients: Stores.IngredientMultiplier[] = [];
  public allergens: Stores.AllergensEntity[] = [];
  private childRecipeEntityDetails: Stores.ChildRecipeEntity;
  private ingredientsEntity: Stores.IngredientsEntity[] = [];
  ingredientDesc: string;

  constructor(
    private alertService: AlertService,
    private proxyService: ProxyService,
    private childRecipeService: ChildRecipeService,
    private customizationService: CustomizationService,
    private menuUtil: MenuUtilityService,
    private modalService: ModalService,
    private logger: LoggingService
  ) {
    this.childRecipeEntity = JSON.parse(sessionStorage.getItem('childR'));
    this.ingredientDesc = this.childRecipeEntity  ? this.childRecipeEntity.ingredientsDescription : null;
  }

  ngOnInit() {
    this.nutritionInfo.calories = 0;
    this.nutritionInfo.totalFat = 0;
    this.nutritionInfo.carbs = 0;
    this.nutritionInfo.weight = 0;
    this.nutritionInfo.dietaryFiber = 0;
    this.nutritionInfo.protein = 0;
    this.nutritionInfo.caloriesFromFat = 0;
    this.nutritionInfo.sugars = 0;
    this.nutritionInfo.saturatedFat = 0;
    this.nutritionInfo.vitaminA = 0;
    this.nutritionInfo.transFat = 0;
    this.nutritionInfo.vitaminC = 0;
    this.nutritionInfo.cholesterol = 0;
    this.nutritionInfo.calcium = 0;
    this.nutritionInfo.sodium = 0;
    this.nutritionInfo.iron = 0;

    this.calculateDefaultNutritionInfo();
  }

  calculateDefaultNutritionInfo() {
    this.selectedIngredients = [];
    // select default ingredients
    this.logger.log('this.childRecipeEntity => ', this.childRecipeEntity);
    if (this.childRecipeEntity.ingredients) {
      if (this.childRecipeEntity.ingredients.length > 0) {
        this.childRecipeEntity.ingredients.forEach(
          (inMulti: Stores.IngredientMultiplier) => {
            this.selectedIngredients.push(inMulti);
          }
        );
      }
    }

    if (this.childRecipeEntity.customizationGroups) {
      if (this.childRecipeEntity.customizationGroups.length > 0) {
        this.childRecipeEntity.customizationGroups.forEach(custGroup => {
          if (custGroup.modifierGroups) {
            custGroup.modifierGroups.forEach(modGroup => {
              let selectedModifier: Stores.ModifiersEntity;
              let selectedSplIns: Stores.SpecialInstructionsEntity;
              if (custGroup.type === 2 && isModifierGroupDefaultSelected(modGroup, custGroup)) {
                const selectedModG = custGroup.modifierGroups.find(a => a.isSelected === true);
                if (!selectedModG) {
                  modGroup.isSelected = true;
                  modGroup.modifiers.forEach(m => {
                    if (m.isDefaultSelected === true) {
                      modGroup.selectedModifier = m.id;
                    }
                  });
                }
              }
              if (modGroup.name === 'Bread') {
                selectedModifier = modGroup.modifiers.find(modifier => {
                  return modifier.id === modGroup.selectedModifier;
                });

                if (modGroup.specialInstructionId) {
                  if (modGroup.specialInstructionId.length > 0) {
                    modGroup.specialInstructionId.forEach(splInstructionId => {
                      selectedSplIns = selectedModifier.specialInstructions.find(
                        splInstruction => {
                          return splInstruction.id === splInstructionId;
                        }
                      );
                      if (selectedSplIns && selectedSplIns.ingredients) {
                        selectedSplIns.ingredients.forEach(ing => {
                          this.selectedIngredients.push(ing);
                        });
                      }
                    });
                  }
                }
              } else {
                if (modGroup.isSelected === true) {
                  if (modGroup.modifiers) {
                    selectedModifier = modGroup.modifiers.find(
                      modifier => modifier.id === modGroup.selectedModifier
                    );
                  }
                } else if (isModifierGroupDefaultSelected(modGroup, custGroup) && modGroup.isSelected) {
                  selectedModifier = modGroup.modifiers.find(
                    modifier => modifier.isDefaultSelected === true
                  );
                }
              }
              if (selectedModifier) {
                selectedModifier.ingredients.forEach(
                  (inMulti: Stores.IngredientMultiplier) => {
                    let selectedIngredient: Stores.IngredientMultiplier;
                    selectedIngredient = this.selectedIngredients.find(
                      ing => ing.ingredientId === inMulti.ingredientId
                    );
                    // if (selectedIngredient) {
                    //   selectedIngredient.multiplier = inMulti.multiplier;
                    //  } else {
                    this.selectedIngredients.push(inMulti);
                    // }
                  }
                );
              }
            });
          }
        });
      }
    }

    this.ingredientsEntity = <Stores.IngredientsEntity[]>this
      .childRecipeEntity.ingredientsList;
    this.selectedIngredients.forEach(
      (inMulti: Stores.IngredientMultiplier) => {
        const ingredient = this.ingredientsEntity.find(
          ing => ing.id === inMulti.ingredientId
        );
        const multiplier = inMulti.multiplier ? inMulti.multiplier : 0;
        if (ingredient) {
          this.getDistinctAllergens(ingredient);
          this.calculateNutrition(ingredient, multiplier);
        }
      }
    );
    this.RoundNutrition(this.nutritionInfo);
  }

  getDistinctAllergens(data: Stores.IngredientsEntity) {
    if (data.allergens) {
      data.allergens.forEach(element => {
        const allergensEntity: Stores.AllergensEntity = element;
        if (!this.allergens.some(a => a.name === allergensEntity.name)) {
          this.allergens.push(element);
        }
      });
    }
  }

  calculateNutrition(element: any, multiplier: any) {
    // tslint:disable-next-line:max-line-length
    this.nutritionInfo.calories += element.nutritionInfo.calories ? Math.round(this.menuUtil.RoundCalories(element.nutritionInfo.calories * multiplier)) : 0;
    this.nutritionInfo.totalFat += element.nutritionInfo.totalFat ? element.nutritionInfo.totalFat * multiplier : 0;
    this.nutritionInfo.carbs += element.nutritionInfo.carbs ? Math.round(element.nutritionInfo.carbs * multiplier) : 0;
    this.nutritionInfo.weight += element.nutritionInfo.weight ? element.nutritionInfo.weight * multiplier : 0;
    this.nutritionInfo.dietaryFiber += element.nutritionInfo.dietaryFiber ? element.nutritionInfo.dietaryFiber * multiplier : 0;
    this.nutritionInfo.protein += element.nutritionInfo.protein ? element.nutritionInfo.protein * multiplier : 0;
    this.nutritionInfo.caloriesFromFat += element.nutritionInfo.caloriesFromFat ? element.nutritionInfo.caloriesFromFat * multiplier : 0;
    this.nutritionInfo.sugars += element.nutritionInfo.sugars ? element.nutritionInfo.sugars * multiplier : 0;
    this.nutritionInfo.saturatedFat += element.nutritionInfo.saturatedFat ?
      Math.round(this.menuUtil.RoundFat(element.nutritionInfo.saturatedFat * multiplier)) : 0;
    this.nutritionInfo.vitaminA += element.nutritionInfo.vitaminA ? element.nutritionInfo.vitaminA * multiplier : 0;
    this.nutritionInfo.transFat += element.nutritionInfo.transFat ?
      Math.round(this.menuUtil.RoundFat(element.nutritionInfo.transFat * multiplier)) : 0;
    this.nutritionInfo.vitaminC += element.nutritionInfo.vitaminC ? Math.round(element.nutritionInfo.vitaminC * multiplier) : 0;
    this.nutritionInfo.cholesterol += element.nutritionInfo.cholesterol ? element.nutritionInfo.cholesterol * multiplier : 0;
    this.nutritionInfo.calcium += element.nutritionInfo.calcium ? element.nutritionInfo.calcium * multiplier : 0;
    this.nutritionInfo.sodium += element.nutritionInfo.sodium ? element.nutritionInfo.sodium * multiplier : 0;
    this.nutritionInfo.iron += element.nutritionInfo.iron ? Math.round(element.nutritionInfo.iron * multiplier) : 0;
  }

  public clickedOutside() {
    this.modalService.hideModal();
  }

  ngOnDestroy() {
    sessionStorage.removeItem('childR');
    sessionStorage.removeItem('parentRecipeIngredients');
    this.subscriptions.unsubscribe();
  }

  RoundNutrition(nutritionInfo: Store.NutritionInfo) {
    nutritionInfo.caloriesFromFat = this.menuUtil.RoundCalories(nutritionInfo.caloriesFromFat);
    nutritionInfo.dietaryFiber = Math.round(nutritionInfo.dietaryFiber);
    nutritionInfo.protein = Math.round(nutritionInfo.protein);
    nutritionInfo.sugars = Math.round(nutritionInfo.sugars);
    nutritionInfo.totalFat = this.menuUtil.RoundFat(nutritionInfo.totalFat);
    nutritionInfo.vitaminA = Math.round(nutritionInfo.vitaminA);
    nutritionInfo.calcium = Math.round(nutritionInfo.calcium);
    nutritionInfo.cholesterol = this.menuUtil.RoundCholesterol(nutritionInfo.cholesterol);
    nutritionInfo.sodium = this.menuUtil.RoundSodium(nutritionInfo.sodium);
    nutritionInfo.weight = Math.round(nutritionInfo.weight);
  }
}
